import { getMemberContact } from "../utils/memberContact";
import StandardCheckin from "../newcomponents/StandardCheckin";
import React, { useState, useEffect } from "react";
import { navigate } from "@reach/router"
import styled from "@emotion/styled";
import { getRecentBought } from "../newcomponents/customerComponents/CustomerRecentAPI";
import PaxWarningModal from '../newcomponents/optioncomponents/PaxWarningModal';
import ReviewOrderModal from "../newcomponents/ReviewOrderModal";
import { UserContext, ActionContext, ThemeContext, LanguageContext } from "../contexts/Context";
import AdvocadoLogin from '../newcomponents/advocadoComponents/AdvocadoLogin';
import PaxModel from "../newcomponents/PaxModel";
import CustomerLogin from '../newcomponents/customerComponents/CustomerLogin';
import TakeAwayModal from '../newcomponents/optioncomponents/TakeAwayModal';
import DeliveryOrNotModal from '../newcomponents/optioncomponents/DeliveryOrNotModal';
import CustomerPrivacy from '../newcomponents/customerComponents/CustomerPrivacy';
import CustomerTerm from '../newcomponents/customerComponents/CustomerTerm';
import moment from 'moment';
import axios from "axios";

const APP_ORDERING_COMPANY_IDS = [
  "677ae529d90797dc89c7091a",
  "6805bc98e75fb1ce8570ff56",
  "68c3e1fa1b4ff1ed132de4b4",
  "699d1acc1523f7fcac052961",
  "6a0e7102403c628d1dcc9e74",
  "6a2f669b1e1a4deb5d29ca91",
];

const CUSTOMIZED_CHECKIN_COMPANY_IDS = [
  "686b1ccebd1cb81a078acc24",
  "6882cd9a7c2193be7aa966e9",
  "681c38df5ec87e7cc007a365"
];

const CheckIn = (props) => {
  const { company } = React.useContext(UserContext);

  useEffect(() => {
    const root = document.getElementById("root");
    if (root) root.classList.add("checkin-wide");

    return () => {
      if (root) root.classList.remove("checkin-wide");
    };
  }, []);

  if (!company) return null;

  // Keep app-only stores out of all QR ordering effects and redirects.
  if (APP_ORDERING_COMPANY_IDS.includes(company._id)) {
    return (
      <AppDownloadPage>
        <AppDownloadCard>
          <AppStoreName>{company.shortName || company.companyName}</AppStoreName>
          <h1>We've moved to the Six Hands app!</h1>
          <p>QR ordering is no longer available at this store. Please download the Six Hands F&amp;B app to place your order.</p>
          <AppDownloadLinks aria-label="Download Six Hands F&B">
            <AppDownloadLink href="https://apps.apple.com/sg/app/six-hands-f-b/id6755752856">
              Download on the App Store
            </AppDownloadLink>
            <AppDownloadLink href="https://play.google.com/store/apps/details?id=com.sixhandsapp&hl=en_SG">
              Get it on Google Play
            </AppDownloadLink>
          </AppDownloadLinks>
          <p>Already have the app? Open Six Hands F&amp;B to order and select the correct store.</p>
        </AppDownloadCard>
      </AppDownloadPage>
    );
  }

  return <OrderingCheckIn {...props} />;
};

const AppDownloadPage = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px 16px;
  box-sizing: border-box;
  background: #0d261c;
  color: #0d261c;
`;

const AppDownloadCard = styled.section`
  width: 100%;
  max-width: 480px;
  padding: 32px 24px;
  box-sizing: border-box;
  border-radius: 24px;
  background: #f6faef;
  text-align: center;

  h1 { font-size: 30px; line-height: 1.2; margin: 20px 0; }
  p { font-size: 16px; line-height: 1.6; }
`;

const AppStoreName = styled.div`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 8px;
  background: #cef580;
  font-size: 20px;
  font-weight: 700;
`;

const AppDownloadLinks = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 28px 0;
`;

const AppDownloadLink = styled.a`
  display: block;
  padding: 16px;
  border-radius: 12px;
  background: #0d261c;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-decoration: none;

  &:hover { background: #234b38; }
  &:focus-visible { outline: 3px solid #397650; outline-offset: 3px; }
`;

const OrderingCheckIn = ({ token, reserveId }) => {

  const { registerUserData, registerPax, updateTitle, setLanIndex, setTkType, addAdCustomer, setReserveData, addCustomer, addTakeAwayInfo, setRecentItem } = React.useContext(ActionContext);
  const { company, ads, theme, hasCategoryScreen, greetingMessage, isTakeAway, isMenuView, skipDIPickUpTime, skipTAPickUpTime, skipCustomerDetail,
    title, supportMultiLan, lanIndex, skipPaxControl, menus, tableLabel, hasMember, haveToLogin, currencySymbol, bgImg,
    tkDiMenuDiff, hasAdvocado, selectPUTimeFirst, deliveryOrNot, hasTakeAway, tkType, takeAwayInfo, includeDineIn, isPreOrder,
    showKitchenStatus, recentBought, isInRoom, hasInitFlow
  } = React.useContext(UserContext);

  const languageContext = React.useContext(LanguageContext);
  const themeContext = React.useContext(ThemeContext);
  const userContext = React.useContext(UserContext);
  const hasCustomizedCheckinLayout = CUSTOMIZED_CHECKIN_COMPANY_IDS.includes(company._id);

  const [memberPhone, setMemberPhone] = useState("");
  const [memberPassword, setMemberPassword] = useState("");
  const [pax, setPax] = useState(0);
  const [isSubmit, setSubmit] = useState(false);
  const [showPax, setShowPax] = useState(false);
  const [time, setTime] = useState("");
  const [warningMsg, setWarningMsg] = useState("");
  const [show, setShow] = useState(false);
  const [showAdvocado, setAdvocado] = useState(false);
  const [showCustomer, setCustomer] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);
  const [showPickUpTime, setShowPickUpTime] = useState(false);
  const [hasFillUp, setHasFillUp] = useState(false);
  const [showTerm, setShowTerm] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // let menus = ['ala carte', 'buffet'];
  const isEnabled = (value) => value === true || value === "true" || value === 1 || value === "1";
  const shouldSkipPickUpForm = (deliveryType) => {
    return !isPreOrder && (
      (deliveryType == 1 && isEnabled(skipDIPickUpTime)) ||
      (deliveryType == 0 && isEnabled(skipTAPickUpTime))
    );
  };

  useEffect(() => {
    sessionStorage.removeItem("menuScrollPosition");
  }, []);

  //reset checkin
  localStorage.setItem("checkIn", new Date().getTime());

  const editPax = (value) => {
    if (pax >= 0 && pax <= themeContext.maxPax) {
      if (value > 0 && pax !== themeContext.maxPax) {
        setPax(pax + value);
      }
      if (value < 0 && pax !== 0) {
        setPax(pax + value);
      }
    }
  };

  useEffect(() => {
    if (pax > 0 && isSubmit) {
      handlingClick();
    }
  }, [pax, isSubmit]);


  useEffect(() => {
    localStorage.removeItem("finalOrder");
    localStorage.removeItem("order");
    localStorage.removeItem("adCustomer");
    localStorage.removeItem("customer");
    updateTitle("");

  }, []);


  useEffect(() => {
   
    localStorage.removeItem("reserveData");
    if (reserveId == "" || reserveId == null) return;
    //pull reservation data
    axios.get('/v2/api/selforder/reserve?reserveId=' + reserveId,
      {
        headers: {
          Authorization: "Bearer " + token,
        }
      })
      .then(function (response) {
        setReserveData(response.data);
        setPax(response.data.pax);
        localStorage.setItem("reserveData", JSON.stringify(response.data));
        registerPax(response.data.pax);
        setTkType(4);
        //skip no of pax, straigh away to menu
        handlingClick();
      });

  }, [reserveId]);


  useEffect(() => {
    let currentDate = new Date().getTime();
    setTime(currentDate);
    //setuser

    const makeid = (length) => {
      var result = [];
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    };

    const generateUserId = () => {
      let currentDate = new Date().getTime();
      return makeid(20) + currentDate;
    };
   
    registerUserData(token, generateUserId(), currentDate);

  }, [registerUserData, token]);

  useEffect(() => {
    const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;
    if (!hasCustomizedCheckinLayout && !isMenuView) return;
    const categoryScreenEnabled = hasCategoryScreen === true || hasCategoryScreen === "true" || hasCategoryScreen === 1 || hasCategoryScreen === "1";
    if (!isDesktop || !categoryScreenEnabled || !menus) return;
    if ((skipPaxControl != null && skipPaxControl === false && skipPaxControl !== "") || tkDiMenuDiff) return;
    if (menus.length === 1) {
      updateTitle(menus[0]);
    }

    navigate("/menu", { replace: true });
  }, [hasCategoryScreen, menus, updateTitle, hasCustomizedCheckinLayout, isMenuView]);

  useEffect(() => {
    if (!menus) return;
    if (!hasCustomizedCheckinLayout && !isMenuView) return;
    if ((skipPaxControl != null && skipPaxControl === true && skipPaxControl !== "" && !tkDiMenuDiff) ||
      (isMenuView != null && isMenuView === true && isMenuView !== '')
    ) {
      if (menus && menus.length > 1) { return; }
      if (menus && menus.length == 1) {
        updateTitle(menus[0]);
      }
      const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;
      // if (hasInitFlow) {
      //   navigate("/initflow");
      // } else 
      if (hasCategoryScreen && !isDesktop)
        navigate("/category");
      else
        navigate("/menu");
      window.history.pushState(null, null, hasCategoryScreen && !isDesktop ? "/category" : "/menu");
    }
  }, [skipPaxControl, menus, isMenuView, hasCustomizedCheckinLayout]);

  const handlingPaxCallback = (pax) => {
    setPax(pax);
    setSubmit(true);
  }
  const handleTitleClick = (title) => () => {
    updateTitle(title);
  }
  const handlingView = () => {
    setShowOrder(true);
  }
  const handleTerm = () => {
    setShowTerm(true);
  }
  const handlePrivacy = () => {
    setShowPrivacy(true);
  }

  const setDeliveryPrice = (value, baseValue = value) => {
    takeAwayInfo.deliveryPrice = value;
    takeAwayInfo.deliveryBasePrice = baseValue;
  

    addTakeAwayInfo(takeAwayInfo);
  }

  const handleChange = (e, name) => {
    if (name == 'phone') {
      takeAwayInfo.phone = e;
      addTakeAwayInfo(takeAwayInfo);
    } else if (name == 'customerName') {
      takeAwayInfo.customerName = e;
      addTakeAwayInfo(takeAwayInfo);
    }
    setWarningMsg("");
  }
  const handleMemberAuthenticated = (member) => {
    const contact = getMemberContact(member);
    addTakeAwayInfo({ ...takeAwayInfo, ...contact });
    setMemberPassword("");
    handlingClick();
  };

  const memberLogin = () => {
    if (!takeAwayInfo) {
      setWarningMsg("Please enter your phone number.");
    } else if (takeAwayInfo.phone == "") {
      setWarningMsg("Please enter your phone number.");
    } else if (takeAwayInfo.phone.length < 8) {
      setWarningMsg("Please enter valid phone number.");
    } else {
      handlingClick();
    }
  }

  const confirmDelivery = async (selectedDeliveryType = tkType) => {
    if (shouldSkipPickUpForm(selectedDeliveryType)) {
      confirmTKCheckOut("", "", moment().valueOf(), "", "", [], selectedDeliveryType, "");
      return;
    }
    setShowPickUpTime(true);
  }
  const confirmTKCheckOut = async (customerName, phone, scheduleTime, address, remark, checkbox, deliveryType, roomNo) => {

    takeAwayInfo.customerName = customerName;
    takeAwayInfo.phone = phone;
    takeAwayInfo.scheduleTime = scheduleTime;
    takeAwayInfo.address = address;
    takeAwayInfo.remark = remark;
    takeAwayInfo.checkbox = checkbox;
    takeAwayInfo.deliveryType = deliveryType;
    takeAwayInfo.roomNo = roomNo;
    takeAwayInfo.saveTime = new Date().getTime();
    setTkType(deliveryType);
    //if has recent bought feature 
    if (recentBought) {
      getRecentBought(phone, token).then(res => {
        setRecentItem(res);
      })
    }
    addTakeAwayInfo(takeAwayInfo);
    setHasFillUp(true);

  };

  useEffect(() => {
    if (hasFillUp) {
      handlingClick();
    }
  }, [hasFillUp])

  const handlingClick = () => {
    if (menus && menus.length == 1) {
      updateTitle(menus[0]);
    }

    let selectedTkType = tkType;
    if (tkDiMenuDiff && isTakeAway) { //dine in, takeaway has different menu, need to setTkType
      let tt = "";
      if (menus && menus.length == 1) {
        tt = menus[0];
      } else {
        tt = title;
      }
      tt = tt.trim().toLocaleLowerCase();
      if (tt.includes("dinein") || tt.includes("dine in")) {
        selectedTkType = 1;
      } else if (reserveId != null && reserveId) {
        selectedTkType = 4;
      } else {
        selectedTkType = 0;
      }
      setTkType(selectedTkType);
    }

    if ((isTakeAway || isPreOrder) && selectPUTimeFirst && !hasFillUp) {
      if ((!isPreOrder && deliveryOrNot && hasTakeAway) || (includeDineIn && !tkDiMenuDiff)) {
        setShowDelivery(true);
      } else if (shouldSkipPickUpForm(selectedTkType)) {
        confirmTKCheckOut("", "", moment().valueOf(), "", "", [], selectedTkType, "");
      } else {
        setShowPickUpTime(true);
      }
      return;
    }

    const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;
    if (pax == 0 && !skipPaxControl && !isTakeAway && (reserveId == "" || reserveId == null) && company._id !== "686b1ccebd1cb81a078acc24") {
      setShowPax(true);
    } else if (menus && menus.length > 1 && title == "") {
      setShow(true);
      // } else if (hasInitFlow) {
      //    registerPax(pax);
      //   navigate("/initflow");
    } else if (ads.length > 0) {
      if (reserveId == "" || reserveId == null) {
        registerPax(pax);
      }
      const destination = hasCategoryScreen && !isDesktop ? "/category" : "/menu";
      navigate(destination);
      window.history.pushState(null, null, destination);
    } else if (hasCategoryScreen && !isDesktop) {
      registerPax(pax);
      navigate("/category");
    } else {
      if (reserveId == "" || reserveId == null) {
        registerPax(pax);
      }
      navigate("/menu");
      window.history.pushState(null, null, "/menu");
    }
  }

  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  const hasMemberLogin = hasAdvocado === true || hasMember === true;
  const canLoginAsGuest = !haveToLogin && company._id !== "686b1ccebd1cb81a078acc24" && company._id !== "6882cd9a7c2193be7aa966e9";
  const allowRegister = isEnabled(userContext.allowRegister);
  const canSignUp = hasMember === true && allowRegister;
  // Member stores get a separate Sign Up button; Advocado keeps the combined label only when registration is on
  const memberLoginLabel = hasMember !== true && allowRegister ? languageContext[lanIndex].MemberLogin : languageContext[lanIndex].memberSignIn;

  return (
    <CheckinBox themeContext={themeContext} bgImg={bgImg}
      userContext={userContext} customizedMobile={hasCustomizedCheckinLayout}>
      {!hasCustomizedCheckinLayout ? <StandardCheckin
        hasMember={hasMemberLogin} canGuest={canLoginAsGuest} loginBusy={showCustomer || showAdvocado || showSignUp}
        phone={memberPhone} password={memberPassword} setPhone={setMemberPhone} setPassword={setMemberPassword}
        onLanguage={setLanIndex} onMenu={updateTitle} onReview={handlingView}
        onMember={() => hasMember ? setCustomer(true) : setAdvocado(true)}
        memberLabel={memberLoginLabel}
        onSignUp={canSignUp ? () => setShowSignUp(true) : undefined}
        onGuest={() => { addCustomer(""); addAdCustomer(""); handlingClick(); }}
      /> : <CheckinShell customizedMobile={hasCustomizedCheckinLayout} compactMobile={hasMemberLogin}>
        {(company._id && supportMultiLan) &&
          <MenuWrapperNew themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} aria-label="Language selection">
            <MenuTitleNew isSelect={lanIndex == 0} themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} onClick={() => setLanIndex(0)}>
              En
            </MenuTitleNew>
            <MenuTitleNew isSelect={lanIndex == 1} themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} onClick={() => setLanIndex(1)}>
              中
            </MenuTitleNew>
          </MenuWrapperNew>
        }
        <CheckinCard themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>
          <WelcomePanel themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} compactMobile={hasMemberLogin}>
            {(company._id == "686b1ccebd1cb81a078acc24" || company._id == '6882cd9a7c2193be7aa966e9') ?
                <> </>
                :
                company._id == '681c38df5ec87e7cc007a365' ?
                  <TipText themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>
                    <div style={{ fontSize: 20, padding: '0 0 8px', fontWeight: 500 }}>Welcome To</div>
                  </TipText>
                  :
                  <TipText themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>
                    <div style={{ fontSize: 28, padding: '0 0 8px', fontWeight: 500 }}>{languageContext[lanIndex].welcome} </div>
                    <div style={{ fontSize: 22, paddingBottom: 8, fontWeight: 500 }}>{company.companyName}</div>
                    {isInRoom ?
                      <div style={{ marginBottom: 6, fontSize: isTakeAway ? 30 : 18 }}>{`${languageContext[lanIndex].roomService}${tableLabel != "In Room" ? ": " + tableLabel : ""}`}</div>
                      :
                      <div style={{ marginBottom: 6, fontSize: isTakeAway ? 30 : 18 }}>{!isTakeAway ? `${languageContext[lanIndex].table}: ${tableLabel}` : (tableLabel != "" ? tableLabel : (includeDineIn ? "" : languageContext[lanIndex].takeAway))}</div>
                    }
                    <div>{greetingMessage}</div>
                    {(hasCustomizedCheckinLayout && !skipPaxControl && !isTakeAway) &&
                      <div style={{ marginTop: 2 }}>{languageContext[lanIndex].noOfPax}</div>
                    }
                  </TipText>
            }
            <MenuImage PromptContainer userContext={userContext}
              customizedMobile={hasCustomizedCheckinLayout}
              compactMobile={hasMemberLogin}
              image={company.companyLogo || userContext.landingImg}
            />
            {company._id == '681c38df5ec87e7cc007a365' &&
              <TipText themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>
                <div style={{ marginBottom: 6, fontSize: isTakeAway ? 30 : 18 }}>{!isTakeAway ? `${languageContext[lanIndex].table}: ${tableLabel}` : (tableLabel != "" ? tableLabel : (includeDineIn ? "" : languageContext[lanIndex].takeAway))}</div>
              </TipText>
            }
          </WelcomePanel>
          <ActionPanel themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} compactMobile={hasMemberLogin}>
            {menus && menus.length > 1 &&
              <MenuWrapper themeContext={themeContext}>
                {menus.map((tt, index) =>
                  <MenuTitle isSelect={title == tt} themeContext={themeContext} key={index} onClick={handleTitleClick(tt)}>
                    {tt}
                  </MenuTitle>
                )}
              </MenuWrapper>
            }
            {company._id == "681c38df5ec87e7cc007a365" &&
              <TipText themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>
                <div style={{ marginBottom: 6, fontSize: 10 }}>{greetingMessage}</div>
              </TipText>
            }
            <PaxContainer themeContext={themeContext} compactMobile={hasMemberLogin}>
              {(hasCustomizedCheckinLayout && !skipPaxControl && !isTakeAway && company._id != "686b1ccebd1cb81a078acc24" && company._id != '6882cd9a7c2193be7aa966e9' && company._id != '681c38df5ec87e7cc007a365') &&
                <PaxButtonContainer themeContext={themeContext} compactMobile={hasMemberLogin}>
                  <PaxNumTitle style={{ fontSize: 24 }} themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout}>Guest: </PaxNumTitle>
                  <PaxButton
                    style={{ fontSize: 38, lineHeight: '26px' }}
                    themeContext={themeContext}
                    customizedMobile={hasCustomizedCheckinLayout}
                    onClick={() => {
                      editPax(-1);
                      let element = document.getElementById("pax");
                      if (element != null) {
                        element.classList.add("pax-animate");
                        setTimeout(() => {
                          element.classList.remove("pax-animate");
                        }, 200);

                      }
                    }}
                  >-</PaxButton>
                  <PaxNum themeContext={themeContext} customizedMobile={hasCustomizedCheckinLayout} id="pax">{pax}</PaxNum>
                  <PaxButton
                    style={{ fontSize: 38, lineHeight: '26px' }}
                    themeContext={themeContext}
                    customizedMobile={hasCustomizedCheckinLayout}
                    onClick={() => {
                      editPax(1);
                      let element = document.getElementById("pax");
                      if (element != null) {
                        element.classList.add("pax-animate");
                        setTimeout(() => {
                          element.classList.remove("pax-animate");
                        }, 200);
                      }

                    }}
                  >+</PaxButton>
                </PaxButtonContainer>
              }
              {(company._id == "686b1ccebd1cb81a078acc24" || company._id == '6882cd9a7c2193be7aa966e9') &&
                <ContentWrapper>
                  <InputWrapper>
                    <ModalContentText
                      fontWeight={400}
                      color={"black"}
                    >
                      {languageContext[lanIndex].name}
                    </ModalContentText>
                    <PhoneWrapper>
                      <Input width={100} value={takeAwayInfo ? takeAwayInfo.customerName : ""} onChange={(e) => { handleChange(e.target.value, 'customerName') }} placeholder="e.g. John" />
                    </PhoneWrapper>
                  </InputWrapper>
                  <InputWrapper>
                    <ModalContentText
                      fontWeight={400}
                      color={"black"}
                    >
                      {languageContext[lanIndex].phone}
                    </ModalContentText>
                    <PhoneWrapper>
                      <Input width={100} value={takeAwayInfo ? takeAwayInfo.phone : ""} onChange={(e) => { handleChange(e.target.value, 'phone') }} placeholder="e.g. 91231111" />
                    </PhoneWrapper>
                  </InputWrapper>

                  {warningMsg &&
                    <InputWrapper>
                      <InputWarningText>
                        {warningMsg}
                      </InputWarningText>
                    </InputWrapper>
                  }
                  <InputWrapper>
                    <LoginButton
                      color={getCheckinText(themeContext)}
                      onClick={memberLogin} >
                      Proceed
                    </LoginButton>
                  </InputWrapper>

                  <InputWrapper>
                    <InputText>
                      By Logging in, you agree to the <a onClick={handleTerm} style={{ color: 'blue', textDecoration: 'underline' }}>Sum Dim Sum Terms</a> of Use and <a onClick={handlePrivacy} style={{ color: 'blue', textDecoration: 'underline' }}>Privacy Policy</a>
                    </InputText>
                  </InputWrapper>
                  <Divider ><DividerText themeContext={themeContext}>{languageContext[lanIndex].or}</DividerText></Divider>
                  <InputWrapper>
                    <Login2Button
                      color={getCheckinText(themeContext)}
                      onClick={handlingClick} >
                      {languageContext[lanIndex].loginAsGuest}
                    </Login2Button>
                  </InputWrapper>

                </ContentWrapper>
              }
              {company._id != "686b1ccebd1cb81a078acc24" && company._id != '6882cd9a7c2193be7aa966e9' &&
                <ReviewButtonWrapper compactMobile={hasMemberLogin}>
                  <ViewBillButton
                    themeContext={themeContext}
                    customizedMobile={hasCustomizedCheckinLayout}
                    onClick={handlingView}
                  >
                    {showKitchenStatus ? languageContext[lanIndex].reviewOrderStatus : isTakeAway ? languageContext[lanIndex].reviewTAOrder : languageContext[lanIndex].reviewOrder}
                  </ViewBillButton>
                </ReviewButtonWrapper>
              }

              {hasAdvocado === true ?
                <AdvocadoBtn
                  theme={theme}
                  themeContext={themeContext}
                  compactMobile={hasMemberLogin}
                  onClick={() => setAdvocado(true)}>
                  {/* <img src={theme != 0 ? "/advocado.png" : ""} style={{ height: 24, width: 24, marginRight: 8 }} /> */}
                  {memberLoginLabel}
                </AdvocadoBtn>
                : <></>
              }
              {hasMember === true ?
                <AdvocadoBtn
                  theme={theme}
                  themeContext={themeContext}
                  compactMobile={hasMemberLogin}
                  onClick={() => setCustomer(true)}>
                  {/* <img src={theme != 0 ? "/advocado.png" : ""} style={{ height: 24, width: 24, marginRight: 8 }} /> */}
                  {memberLoginLabel}
                </AdvocadoBtn>
                : <></>
              }
              {canSignUp &&
                <AdvocadoBtn
                  theme={theme}
                  themeContext={themeContext}
                  compactMobile={hasMemberLogin}
                  onClick={() => setShowSignUp(true)}>
                  {languageContext[lanIndex].register}
                </AdvocadoBtn>
              }
              {hasMemberLogin && canLoginAsGuest &&
                <Divider compactMobile><DividerText themeContext={themeContext}>{languageContext[lanIndex].or}</DividerText></Divider>
              }
              {canLoginAsGuest &&
                <EnterButton
                  themeContext={themeContext}
                  compactMobile={hasMemberLogin}
                  onClick={() => {
                    addCustomer("");
                    addAdCustomer("");
                    handlingClick();
                  }}
                >
                  {hasCustomizedCheckinLayout ? (hasMemberLogin ? languageContext[lanIndex].loginAsGuest : languageContext[lanIndex].enter) : (hasMemberLogin ? languageContext[lanIndex].continueAsGuest : languageContext[lanIndex].continueCheckin)}
                </EnterButton>
              }
            </PaxContainer>
          </ActionPanel>
        </CheckinCard>
      </CheckinShell>}
      <PaxWarningModal
        pax={pax}
        menus={menus}
        title={title}
        show={show}
        setShow={setShow}
      />
      {showOrder &&
        <ReviewOrderModal
          show={showOrder}
          setShow={setShowOrder}
        />
      }
      {showAdvocado &&
        <AdvocadoLogin
          initialPassword={hasCustomizedCheckinLayout ? undefined : memberPassword}
          submitOnOpen={!hasCustomizedCheckinLayout}
          initialPhone={hasCustomizedCheckinLayout ? undefined : memberPhone}
          show={showAdvocado}
          setShow={setAdvocado}
          handleCallback={hasCustomizedCheckinLayout ? handlingClick : handleMemberAuthenticated}
        />
      }
      {showCustomer &&
        <CustomerLogin
          initialPhone={hasCustomizedCheckinLayout ? undefined : memberPhone}
          initialPassword={hasCustomizedCheckinLayout ? undefined : memberPassword}
          submitOnOpen={!hasCustomizedCheckinLayout}
          show={showCustomer}
          setShow={setCustomer}
          handleCallback={handlingClick}
        />
      }
      {showSignUp &&
        <CustomerLogin
          registerOnly
          initialPhone={hasCustomizedCheckinLayout ? undefined : memberPhone}
          show={showSignUp}
          setShow={setShowSignUp}
          handleCallback={handlingClick}
        />
      }
      {showPax &&
        <PaxModel
          show={showPax}
          setShow={setShowPax}
          handleCallback={handlingPaxCallback}
        />
      }
      {showPickUpTime &&
        <TakeAwayModal show={showPickUpTime} setShowTk={setShowPickUpTime} deliveryType={tkType} confirmTKCheckOut={confirmTKCheckOut}
          setDeliveryPrice={setDeliveryPrice} deliveryPrice={takeAwayInfo ? takeAwayInfo.deliveryPrice : 0} lanIndex={lanIndex} totalAmount={0} currencySymbol={currencySymbol} />
      }
      {showDelivery &&
        <DeliveryOrNotModal
          show={showDelivery}
          setShowDelive={setShowDelivery}
          type={tkType}
          setDeliveryType={setTkType}
          deliveryOrNot={deliveryOrNot}
          confirmDelivery={confirmDelivery}
          lanIndex={lanIndex}
          deliveryPrice={takeAwayInfo ? takeAwayInfo.deliveryPrice : 0}
          currencySymbol={currencySymbol}
          includeDineIn={includeDineIn}
          setDeliveryPrice={setDeliveryPrice}
          tkDiMenuDiff={tkDiMenuDiff}
          hasTakeAway={hasTakeAway} />
      }
      {showTerm &&
        <CustomerTerm
          show={showTerm}
          setShow={setShowTerm}
        />

      }
      {showPrivacy &&
        <CustomerPrivacy
          show={showPrivacy}
          setShow={setShowPrivacy}
        />

      }
    </CheckinBox>
  );
};

export default CheckIn;

const normalizeColor = (color) => {
  if (!color) return null;
  const namedColors = { black: "#000000", white: "#ffffff" };
  const normalized = namedColors[String(color).toLowerCase()] || color;
  const match = String(normalized).trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!match) return null;
  const value = match[1].length === 3
    ? match[1].split("").map((character) => character + character).join("")
    : match[1];
  return `#${value.toLowerCase()}`;
};

const colorLuminance = (color) => {
  const normalized = normalizeColor(color);
  if (!normalized) return null;
  const channels = [1, 3, 5].map((offset) => parseInt(normalized.slice(offset, offset + 2), 16) / 255)
    .map((channel) => channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4));
  return (0.2126 * channels[0]) + (0.7152 * channels[1]) + (0.0722 * channels[2]);
};

const colorContrast = (firstColor, secondColor) => {
  const first = colorLuminance(firstColor);
  const second = colorLuminance(secondColor);
  if (first === null || second === null) return 0;
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
};

const getCheckinSurface = (themeContext) => themeContext.checkInSurfaceColor || "#ffffff";
const getCheckinAccent = (themeContext) => themeContext.checkInAccentColor || themeContext.checkInSecondaryColor || themeContext.primaryColor || "#0f172a";
const getCustomizedCheckinColor = (themeContext) => themeContext.checkInSecondaryColor || themeContext.primaryColor || "#0f172a";

const getBestContrastColor = (backgroundColor) => {
  if (colorLuminance(backgroundColor) === null) return "#0f172a";
  return colorContrast("#ffffff", backgroundColor) >= colorContrast("#0f172a", backgroundColor)
    ? "#ffffff"
    : "#0f172a";
};

const getCheckinText = (themeContext) => {
  const surface = getCheckinSurface(themeContext);
  const preferred = themeContext.checkInTextColor || themeContext.fontPrimary;
  return colorContrast(preferred, surface) >= 4.5 ? preferred : getBestContrastColor(surface);
};

const getCheckinAccentText = (themeContext) => {
  const surface = getCheckinSurface(themeContext);
  const preferred = themeContext.checkInAccentTextColor || getCheckinAccent(themeContext);
  if (colorContrast(preferred, surface) >= 4.5) return preferred;
  return getCheckinText(themeContext);
};

const getCheckinButtonText = (themeContext) => {
  const accent = getCheckinAccent(themeContext);
  const preferred = themeContext.checkInButtonTextColor || themeContext.checkInEnterColor || themeContext.checkInPrimaryColor;
  return colorContrast(preferred, accent) >= 4.5 ? preferred : getBestContrastColor(accent);
};

const CheckinShell = styled.main`
  position: relative;
  z-index: 1;
  width: ${(props) => props.customizedMobile ? "min(100%, 550px)" : "min(100%, 1040px)"};
  min-height: ${(props) => props.customizedMobile ? "100dvh" : "auto"};
  padding: ${(props) => props.customizedMobile ? "0" : "64px 24px 32px"};
  box-sizing: border-box;

  @media (max-width: 767px) {
    display: flex;
    min-height: 100dvh;
    padding: ${(props) => props.customizedMobile ? "0" : props.compactMobile ? "44px 8px 6px" : "52px 8px 8px"};
    flex-direction: column;
  }
`;

const CheckinCard = styled.div`
  ${props => !props.customizedMobile && `
    @media (min-width: 768px) {
      && { display: flex; flex-direction: column; min-height: 0; max-width: 560px; margin: 0 auto; border-radius: 24px; }
      > section:first-child { padding: 32px 32px 16px; }
      > section:last-child { padding: 16px 40px 32px; }
    }
  `}
  display: ${(props) => props.customizedMobile ? "flex" : "grid"};
  grid-template-columns: ${(props) => props.customizedMobile ? "none" : "minmax(0, 1.08fr) minmax(360px, 0.92fr)"};
  width: 100%;
  box-sizing: border-box;
  min-height: ${(props) => props.customizedMobile ? "100dvh" : "min(680px, calc(100dvh - 96px))"};
  flex-direction: ${(props) => props.customizedMobile ? "column" : "initial"};
  justify-content: ${(props) => props.customizedMobile ? "center" : "initial"};
  overflow: ${(props) => props.customizedMobile ? "visible" : "hidden"};
  border: ${(props) => props.customizedMobile ? "0" : `1px solid ${props.themeContext.borderColor || "rgba(17, 24, 39, 0.08)"}`};
  border-radius: ${(props) => props.customizedMobile ? "0" : "30px"};
  background: ${(props) => props.customizedMobile ? "transparent" : getCheckinSurface(props.themeContext)};
  box-shadow: ${(props) => props.customizedMobile ? "none" : "0 28px 80px rgba(15, 23, 42, 0.22)"};

  @media (max-width: 767px) {
    display: flex;
    min-height: ${(props) => props.customizedMobile ? "100dvh" : "calc(100dvh - 60px)"};
    flex: ${(props) => props.customizedMobile ? "none" : "1 0 auto"};
    flex-direction: column;
    justify-content: ${(props) => props.customizedMobile ? "center" : "flex-start"};
    overflow: ${(props) => props.customizedMobile ? "visible" : "hidden"};
    border: ${(props) => props.customizedMobile ? "0" : "inherit"};
    border-radius: ${(props) => props.customizedMobile ? "0" : "24px"};
    background: ${(props) => props.customizedMobile ? "transparent" : getCheckinSurface(props.themeContext)};
    box-shadow: ${(props) => props.customizedMobile ? "none" : "0 18px 48px rgba(15, 23, 42, 0.18)"};
  }
`;

const WelcomePanel = styled.section`
  display: flex;
  min-width: 0;
  padding: ${(props) => props.customizedMobile ? "0" : "48px"};
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => getCheckinText(props.themeContext)};
  background: ${(props) => props.customizedMobile
    ? "transparent"
    : `radial-gradient(circle at 15% 10%, rgba(255, 255, 255, 0.9), transparent 38%), ${props.themeContext.checkInWelcomeBackground || "linear-gradient(145deg, rgba(248, 250, 252, 0.98), rgba(238, 242, 247, 0.92))"}`};

  @media (max-width: 767px) {
    padding: ${(props) => props.customizedMobile ? "0" : props.compactMobile ? "14px 16px 8px" : "22px 16px 16px"};
    background: ${(props) => props.customizedMobile ? "transparent" : "linear-gradient(145deg, rgba(248, 250, 252, 0.98), rgba(238, 242, 247, 0.92))"};
  }
`;

const ActionPanel = styled.section`
  display: flex;
  min-width: 0;
  padding: ${(props) => props.customizedMobile ? "0" : "48px 42px"};
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  color: ${(props) => getCheckinText(props.themeContext)};
  background: ${(props) => props.customizedMobile ? "transparent" : getCheckinSurface(props.themeContext)};

  @media (max-width: 767px) {
    padding: ${(props) => props.customizedMobile ? "0" : props.compactMobile ? "8px 16px 14px" : "18px 16px 24px"};
    background: ${(props) => props.customizedMobile ? "transparent" : getCheckinSurface(props.themeContext)};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;
const Login2Button = styled.div`
  display: flex;
  width: 100%;
  min-height: 44px;
  margin: 2px auto;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.color};
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  cursor: pointer;
`;

const LoginButton = styled.div`
  display: flex;
  width: 80%;
  min-height: 48px;
  margin: 8px auto;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.color};
  font-size: 17px;
  font-weight: 700;
  border-radius: 14px;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.14);
  cursor: pointer;
`;
const InputText = styled.div`
  width: 80%;
  color: #64748b;
  font-size: 11px;
  line-height: 1.5;
`;
const InputWarningText = styled.div`
  width: 80%;
  margin-bottom: 8px;
  color: #dc2626;
  font-size: 12px;
`;
const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const ModalContentText = styled.div`
  width: 80%;
  margin-bottom: 7px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
`;
const PhoneWrapper = styled.div`
    display: flex;
    width: 80%;
`;
const Input = styled.input`
  width: ${(props) => props.width}%;
  height: 48px;
  padding: 0 15px;
  box-sizing: border-box;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  margin-bottom: 16px;
  color: #0f172a;
  background: #fff;
  font-size: 16px;

  &:focus {
    border-color: #64748b;
    outline: none;
    box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.14);
  }
`;

const AdvocadoBtn = styled.div`
  display:${(props) => props.theme == 0 ? "none" : "flex"};
  width: ${(props) => props.theme == 0 ? "0px" : "100%"};
  max-width: 360px;
  min-height: 48px;
  background-color: ${(props) => getCheckinSurface(props.themeContext)};
  color: ${(props) => getCheckinAccentText(props.themeContext)};
  margin: 10px auto 0;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => getCheckinAccent(props.themeContext)};
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 7px 18px rgba(15, 23, 42, 0.12);
  }

  @media (max-width: 767px) {
    min-height: ${(props) => props.compactMobile ? "44px" : "48px"};
    margin-top: ${(props) => props.compactMobile ? "6px" : "10px"};
  }
`;
const DividerText = styled.div`
  padding: 0 2px;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1;
  background: transparent;
`;
const Divider = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: minmax(24px, 1fr) auto minmax(24px, 1fr);
  gap: 12px;
  align-items: center;
  margin: 16px 0;

  &:before,
  &:after {
    content: " ";
    width: 100%;
    height: 1px;
    background: #e2e8f0;
  }

  @media (max-width: 767px) {
    margin: ${(props) => props.compactMobile ? "8px 0 4px" : "16px 0"};
  }
`;


const CheckinBox = styled.div`
  position: relative;
  display: flex;
  width: ${(props) => props.customizedMobile ? "100vw" : "100%"};
  max-width: ${(props) => props.customizedMobile ? "550px" : "none"};
  min-height: 100dvh;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: ${(props) => props.themeContext.fontFamily || "inherit"};
  background-color: ${(props) => props.themeContext.checkInbackgroundColor || getCheckinSurface(props.themeContext)};
  background-image: ${(props) => props.customizedMobile
    ? `url(${props.bgImg ? "https://ireachfnb.com/" + props.bgImg : ""})`
    : `linear-gradient(rgba(15, 23, 42, 0.38), rgba(15, 23, 42, 0.54)), url(${props.bgImg ? "https://ireachfnb.com/" + props.bgImg : ""})`};
  background-position: center;
  background-size: cover;

  @media (min-width: 768px) {
    margin-inline: ${(props) => props.customizedMobile ? "auto" : "0"};
  }

  @media (max-width: 767px) {
    background-image: ${(props) => props.customizedMobile
    ? `url(${props.bgImg ? "https://ireachfnb.com/" + props.bgImg : ""})`
    : `linear-gradient(rgba(15, 23, 42, 0.38), rgba(15, 23, 42, 0.54)), url(${props.bgImg ? "https://ireachfnb.com/" + props.bgImg : ""})`};
  }
`;
const TipText = styled.div`
  width: 100%;
  max-width: 480px;
  text-align: center;
  margin: 0 auto;
  color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  font-size: 16px;
  line-height: 1.5;

  @media (max-width: 767px) {
    color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  }
`;
const MenuImage = styled.div`
  width: ${(props) => props.customizedMobile ? "150px" : "180px"};
  min-height: ${(props) => props.customizedMobile ? "150px" : "180px"};
  margin: ${(props) => props.customizedMobile ? "3vh auto" : "30px auto"};
  border: ${(props) => props.customizedMobile ? "0" : "1px solid rgba(148, 163, 184, 0.22)"};
  border-radius: ${(props) => props.customizedMobile ? "50%" : "28px"};
  background-image: url(${(props) => `https://ireachfnb.com${props.image}` || '/toppings/toppings.jpg'});
  /*background-image: url(${(props) => `https://newdemo.chachingfnb.com${props.image}` || '/toppings/toppings.jpg'});*/
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) => props.customizedMobile ? "transparent" : "rgba(255, 255, 255, 0.88)"};
  box-shadow: ${(props) => props.customizedMobile ? "none" : "0 18px 42px rgba(15, 23, 42, 0.15)"};

  @media (max-width: 767px) {
    width: ${(props) => props.customizedMobile ? props.compactMobile ? "120px" : "150px" : props.compactMobile ? "96px" : "120px"};
    min-height: ${(props) => props.customizedMobile ? props.compactMobile ? "120px" : "150px" : props.compactMobile ? "96px" : "120px"};
    margin: ${(props) => props.customizedMobile ? props.compactMobile ? "1.5vh auto" : "3vh auto" : props.compactMobile ? "8px auto" : "16px auto"};
 border: ${(props) => props.customizedMobile ? "0" : "1px solid rgba(148, 163, 184, 0.22)"};
    border-radius: ${(props) => props.customizedMobile ? "50%" : "22px"};
    background-color: ${(props) => props.customizedMobile ? "transparent" : "rgba(255, 255, 255, 0.88)"};
    box-shadow: ${(props) => props.customizedMobile ? "none" : "0 18px 42px rgba(15, 23, 42, 0.15)"};
  }
`;

const PaxContainer = styled.div`
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
`;

const PaxButton = styled.div`
  &:active{
    background: rgba(0,0,0,0.1);
  }
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  color: ${(props) => getCheckinAccentText(props.themeContext)};
  border: 1px solid ${(props) => props.themeContext.borderColor || "#e2e8f0"};
  background: ${(props) => getCheckinSurface(props.themeContext)};
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
  cursor: pointer;
  transition: transform 120ms ease, background 120ms ease;

  &:hover {
    transform: scale(1.04);
  }

  @media (max-width: 767px) {
    color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  }
`;
const PaxButtonContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 14px;
  box-sizing: border-box;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  border: 1px solid ${(props) => props.themeContext.borderColor || "#e2e8f0"};
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.78);

  @media (max-width: 767px) {
    padding: ${(props) => props.compactMobile ? "8px 10px" : "12px 14px"};
  }
`;
const PaxNumTitle = styled.div`
  margin-right: auto;
  padding: 0 12px 0 2px;
  font-size: 17px !important;
  font-weight: 600;
  color: ${(props) => getCheckinAccentText(props.themeContext)};

  @media (max-width: 767px) {
    color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  }
`;
const PaxNum = styled.div`
  min-width: 46px;
  padding: 0 8px;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  color: ${(props) => getCheckinAccentText(props.themeContext)};

  @media (max-width: 767px) {
    color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  }

`;
const EnterButton = styled.div`
  width: 100%;
  max-width: 360px;
  min-height: 52px;
  border-radius: 15px;
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  line-height: 52px;
  margin: 20px auto 8px;
  background: ${(props) => getCheckinAccent(props.themeContext)};
  color: ${(props) => getCheckinButtonText(props.themeContext)};
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.2);
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 11px 26px rgba(15, 23, 42, 0.24);
  }

  @media (max-width: 767px) {
    min-height: ${(props) => props.compactMobile ? "44px" : "52px"};
    margin: ${(props) => props.compactMobile ? "4px auto 0" : "20px auto 8px"};
    line-height: ${(props) => props.compactMobile ? "44px" : "52px"};
  }
`;
const ReviewButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;

  @media (max-width: 767px) {
    margin-top: ${(props) => props.compactMobile ? "10px" : "24px"};
  }
`;
const ViewBillButton = styled.div`
  text-align: center;
  width: fit-content;
  padding: 9px 14px;
  border-radius: 10px;
  background: rgba(148, 163, 184, 0.1);
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => getCheckinAccentText(props.themeContext)};
  cursor: pointer;

  @media (max-width: 767px) {
    color: ${(props) => props.customizedMobile ? getCustomizedCheckinColor(props.themeContext) : getCheckinAccentText(props.themeContext)};
  }
`;

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 4px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 22px;
  border-radius: 14px;
  background: rgba(148, 163, 184, 0.1);
`;
const MenuTitle = styled.div`
  display:flex;
  min-height: 40px;
  padding: 0 15px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => !props.isSelect ? "transparent" : getCheckinAccent(props.themeContext)};
  border-radius: 10px;
  color:${(props) => !props.isSelect ? getCheckinAccentText(props.themeContext) : getCheckinButtonText(props.themeContext)};
  transition: all 0.2s;
  font-size: 15px;
  font-weight: 600;
  text-align:center;
  cursor: pointer;
`;
const MenuWrapperNew = styled.div`
  position: absolute;
  top: ${(props) => props.customizedMobile ? "15px" : "14px"};
  right: ${(props) => props.customizedMobile ? "15px" : "24px"};
  z-index: 3;
  display: flex;
  padding: ${(props) => props.customizedMobile ? "0" : "4px"};
  border: ${(props) => props.customizedMobile ? "0" : "1px solid rgba(255, 255, 255, 0.34)"};
  border-radius: ${(props) => props.customizedMobile ? "0" : "14px"};
  background: ${(props) => props.customizedMobile ? "transparent" : "rgba(15, 23, 42, 0.34)"};
  backdrop-filter: ${(props) => props.customizedMobile ? "none" : "blur(12px)"};

  @media (max-width: 767px) {
    right: 16px;
  }
`;
const MenuTitleNew = styled.div`
  width: fit-content;
  background-color: ${(props) => props.customizedMobile ? props.themeContext.primaryColor : getCheckinAccent(props.themeContext)};
  border-radius: ${(props) => props.customizedMobile ? "6px" : "10px"};
  font-size: ${(props) => props.customizedMobile ? "16px" : "14px"};
  font-weight: ${(props) => props.customizedMobile ? "400" : "700"};
  color: ${(props) => props.customizedMobile ? props.themeContext.checkInPrimaryColor : getCheckinButtonText(props.themeContext)};
  text-align: center;
  display: ${(props) => !props.isSelect ? 'block' : "none"};
  margin: 0;
  padding: ${(props) => props.customizedMobile ? "2px 8px" : "3px 12px"};
  line-height: ${(props) => props.customizedMobile ? "26px" : "28px"};
  box-shadow: ${(props) => props.customizedMobile ? "0 1px 3px rgba(0,0,0,0.3)" : "0 4px 12px rgba(0,0,0,0.16)"};
  cursor: pointer;
`;
